<template>
    <section class="row-12">
        <div class="col-12">
            <h2 class="col-6">Podgląd animacji</h2>
            <p>Pełny podgląd Twojej pracy wraz z informacjami.</p>
        </div>
        <div class="card col-sm-12 col-md-12 col-lg-10 col-offset-lg-1 col-8 col-offset-2 col-offset-sm-0 col-offset-md-0">
            <div class="row-12">
                <div class="video-container col-6 col-sm-12">
                    <video class="w-100" controls>
                        <source v-if="animationData && animationData.url" :src="animationData.url" type="video/mp4">
                    </video>
                </div>
                <div class="card-body col-6 col-sm-12 ">
                    <div class="row-12">
                        <div class="col-4 flex-align-left center-flex-y" >
                            <i class="i-calendar text-primary i-md"></i>
                            <small> {{animationData.date_add}}</small>
                        </div>
                        <div class="col-8 flex-align-right" style="height: auto;">
                            <div class="center-flex-a" v-if="animationData && (animationData.player_min) || (animationData.player_max)">
                                <i class="i-multi-users text-primary i-md"></i>
                                <small> <b>{{animationData.player_min}} - {{animationData.player_max}}</b> osób</small>
                            </div>
                            <div class="center-flex-a m-l-2" v-if="animationData && (animationData.time_min) || (animationData.time_max)">
                                <i class="i-plus text-primary i-md"></i>
                                <small> <b>{{animationData.time_min}} - {{animationData.time_max}}</b> minut</small>
                            </div>
                        </div>
                    </div>
                    <h3 class="m-y-2">{{animationData.name}}</h3>
                    <p >{{animationData.description}}</p>
                    <p v-if="animationData.equipment"class="m-t-3 m-b-a">Akcesoria:</p>
                    <small v-if="animationData.equipment">{{animationData.equipment}}</small>
                    <p v-if="animationData.game_field" class="m-t-3 m-b-a">Pozycja na boisku:</p>
                    <small v-if="animationData.game_field">{{animationData.game_field}}</small>
                    <p class="m-t-3 m-b-a descNoP">Wskazówki:</p>
                    <small >{{animationData.tips}}</small>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AnimationView",
        data: function(){
            return {
                animationData: {},
            }
        },
        mounted: function(){
            axios.get(`animations/${this.$route.params.id}`)
                .then((response)=>{
                    this.animationData = response.data;
                    this.animationData.equipment = this.animationData.equipment.length > 3 ? JSON.parse(this.animationData.equipment) : null;
                    this.animationData.equipment = this.animationData.equipment.join(",");
                })
        }
    }
</script>

<style >
    .descNoP p{
        margin: 0 !important;
    }

    .descNoP ul{
        margin: 0 !important;
    }

    .video-container {
        padding: 20px;
    }

    .card-body .i-calendar {
        margin-left: 0;
    }
</style>
